import styled from "styled-components";

export const MiniPlayerStyle = styled.div`
  max-width: 400px;
  width: 100%;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  .video {
    iframe {
      height: 250px;
    }
  }
  .bottom {
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 10px 15px 15px 15px;
    .drag {
      cursor: move;
      margin-right: 10px;
    }
    .title {
      margin-bottom: 0;
      white-space: nowrap;
      width: 260px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .right {
      margin-left: auto;
      .fullscreen {
        margin-right: 20px;
      }
    }
    .close {
      svg {
        width: 22px;
        height: 22px;
        stroke: red;
        cursor: pointer;
      }
    }
  }
`;
